import { render } from "./Timbres.vue?vue&type=template&id=514c4b8c&scoped=true"
import script from "./Timbres.vue?vue&type=script&lang=js"
export * from "./Timbres.vue?vue&type=script&lang=js"

import "./Timbres.vue?vue&type=style&index=0&id=514c4b8c&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514c4b8c"]])

export default __exports__